import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-modal-succes-enjoy-cl',
  templateUrl: './modal-succes-enjoy-cl.component.html',
  styleUrls: ['./modal-succes-enjoy-cl.component.scss']
})
export class ModalSuccesEnjoyClComponent implements OnInit {

  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(
    private bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
  }

  cerraModal() {
    this.passEntry.emit(true);
    this.bsModalRef.hide();
  }

}
